// =========================
// ServiciosEditor.jsx
// =========================
import React, { useEffect, useState } from "react";
import { db, storage } from "../../firebase";
import {
  collection,
  getDocs,
  orderBy,
  query,
  doc,
  updateDoc,
  addDoc,
  setDoc,
  getDoc,
  serverTimestamp,
} from "firebase/firestore";
import { ref as storageRef, uploadBytes, getDownloadURL } from "firebase/storage";



// =========================
// Helpers variantes
// =========================
const detectarTipoVariantes = (variantesRaw) => {
  if (Array.isArray(variantesRaw)) return "array";
  if (typeof variantesRaw === "string") return "string";
  if (typeof variantesRaw === "object" && variantesRaw !== null) return "map";
  return "array";
};

const normalizarVariantes = (variantesRaw) => {
  if (Array.isArray(variantesRaw)) return variantesRaw;
  if (typeof variantesRaw === "string") return [];
  if (typeof variantesRaw === "object" && variantesRaw !== null) {
    return Object.entries(variantesRaw).flatMap(([nivel, arr]) =>
      arr.map((v) => ({
        ...v,
        nivel,
      }))
    );
  }
  return [];
};

const normalizarVariantesParaEdicion = (variantesRaw) => {
  if (!variantesRaw) return [];

  if (Array.isArray(variantesRaw)) {
    return variantesRaw.map((v, index) => ({
      id: v.id || `var-${index}`,
      nombre: v.nombre || "",
      precio:
        v.precio ||
        v.precio_privada ||
        v.precio_grupo ||
        0,
      precio_grupo:
        v.precio_grupo ??
        (v.modalidadesPermitidas?.grupal
          ? v.precio ?? ""
          : ""),

      precio_privada:
        v.precio_privada ??
        (v.modalidadesPermitidas?.privada !== false
          ? v.precio ?? ""
          : ""),
      nivel: v.nivel || "",

      modalidadesPermitidas:
        v.modalidadesPermitidas || {
          privada: true,
          grupal: false,
        },
    }));
  }

    if (typeof variantesRaw === "object") {

    return Object.entries(
    variantesRaw

    ).flatMap(([nivel,arr],iGrupo)=>

    (arr||[]).map((v,index)=>({

    id:
    v.id ||

    `var-${iGrupo}-${index}`,

    nombre:
    v.nombre || "",

    precio:

    v.precio ||

    v.precio_privada ||

    v.precio_grupo ||

    0,

    precio_grupo:

    (v.precio_grupo > 0)

    ? v.precio_grupo

    : (
        v.modalidadesPermitidas?.grupal

        ? (v.precio ?? "")

        : ""
      ),

    precio_privada:

    (v.precio_privada > 0)

    ? v.precio_privada

    : (
        v.modalidadesPermitidas?.privada !== false

        ? (v.precio ?? "")

        : ""
      ),

    modalidadesPermitidas:

    v.modalidadesPermitidas || {

    privada:true,

    grupal:false

    },

    nivel,

    }))

    )

    }

  return [];
};

const denormalizarVariantesDesdeEdicion = (tipo, variantesList, texto) => {
  if (tipo === "string") return texto || "Próximamente";

  if (tipo === "array") {
    return variantesList.map((v) => ({
      id: v.id,
      nombre: v.nombre,

      precio:

        Number(v.precio_privada) ||

        Number(v.precio_grupo) ||

        0,

      precio_grupo:
        Number(v.precio_grupo) ||
        Number(v.precio) ||
        0,

      precio_privada:
        Number(v.precio_privada) || 0,

      modalidadesPermitidas:
        v.modalidadesPermitidas || {
          privada: true,
          grupal: false,
        },
    }));
  }

if (tipo === "map") {

const grouped = {};

variantesList.forEach((v)=>{

const nivel =
v.nivel || "General";

if(!grouped[nivel])
grouped[nivel]=[];

grouped[nivel].push({

id:v.id,

nombre:v.nombre,

precio:

Number(v.precio_privada) ||

Number(v.precio_grupo) ||

0,

precio_grupo:

Number(v.precio_grupo) ||

0,

precio_privada:

Number(v.precio_privada) ||

0,

modalidadesPermitidas:

v.modalidadesPermitidas || {

privada:true,

grupal:false

}

});

});

return grouped;

}

  return variantesList;
};

const extraerNumero = (txt = "") => {
  const m = String(txt).match(/\d+/);
  return m ? Number(m[0]) : null;
};

const slug = (s = "") =>
  String(s)
    .toLowerCase()
    .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

const extraerTag = (nombre = "") => {
  const t = nombre.toLowerCase();
  if (t.includes("fonasa")) return "fonasa";
  if (t.includes("isapre")) return "isapre";
  if (t.includes("particular")) return "particular";
  return ""; // si no hay tag conocido
};

const normalizarTexto = (s = "") =>
  String(s)
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim();

const TITULOS_PROTEGIDOS_REGLAS = [
  /kinesiologia/,
  /\bkine\b/,
  /entrenamiento/,
  /\bentreno\b/,
  /plan(?:es)?\s+de?\s*entrenamiento/,
  /masoterapia/,
  /masajes?/,
  /recovery/,
];

const getMotivoTituloBloqueado = (titulo = "") => {
  const t = normalizarTexto(titulo);

  if (!t) return "";

  const coincide = TITULOS_PROTEGIDOS_REGLAS.some((rx) => rx.test(t));
  if (!coincide) return "";

  return 'Advertencia: ya existe una lógica automática asociada a servicios de Kinesiología, Entrenamiento, Masajes, Recovery o similares. Si mantienes este nombre, podrías corromper el flujo de sesiones o automatizaciones.';
};

const nextCorrelativo = (servicioId, list) => {
  const re = new RegExp(`^${servicioId}-(\\d+)$`);
  let max = 0;
  (list || []).forEach((v) => {
    const mm = String(v.id || "").match(re);
    if (mm) max = Math.max(max, Number(mm[1]));
  });
  return max + 1;
};

const canonizarIdVariante = ({ servicioId, v, list }) => {
  const id = String(v.id || "").trim();

  // Si ya viene bien (ej: kinesiologia-10-fonasa), lo respetamos
  if (id.startsWith(`${servicioId}-`) && !id.startsWith("tmp-") && !id.startsWith("var-")) {
    return id;
  }

  // Base por número del nombre
  const n = extraerNumero(v.nombre);
  if (n) {
    const tag = extraerTag(v.nombre);
    const baseNombre = slug(v.nombre);

    const candidato = tag
      ? `${servicioId}-${baseNombre}-${tag}`
      : `${servicioId}-${baseNombre}`;

    // Si el candidato ya existe en otra variante, fallback a correlativo
    const usado = (list || []).some((x) => x !== v && String(x.id || "").trim() === candidato);
    if (!usado) return candidato;
  }

  // fallback: correlativo seguro
  return `${servicioId}-${nextCorrelativo(servicioId, list)}`;
};

// =========================
// MODAL EDICIÓN
// =========================
function EditarServicioModal({
  servicio,
  servicios,
  onClose,
  onUpdated,
}) {
  const [saving, setSaving] = useState(false);

  const tipoInicial = detectarTipoVariantes(servicio.variantes);
  const [tipoVariantes] = useState(tipoInicial);

  const [activo, setActivo] = useState(!!servicio.activo);
  const [title, setTitle] = useState(servicio.title || "");
  const [desc, setDesc] = useState(servicio.desc || "");
  const [extra, setExtra] = useState(servicio.extra || "");
  const [image, setImage] = useState(servicio.image || "");
  const [imageFile, setImageFile] = useState(null);
  const [subiendoImagen, setSubiendoImagen] = useState(false);
  const [orden, setOrden] = useState(servicio.orden || servicio.order || 0);

  const [variantesTexto, setVariantesTexto] = useState(
    typeof servicio.variantes === "string" ? servicio.variantes : "Próximamente"
  );

  const [variantesList, setVariantesList] = useState(
    normalizarVariantesParaEdicion(servicio.variantes)
  );

  const tituloNormalizado = normalizarTexto(title);

  const usaTituloProtegido = TITULOS_PROTEGIDOS_REGLAS.some((rx) =>
    rx.test(tituloNormalizado)
  );

  // Buscar si existe OTRO servicio activo usando lógica protegida
  const existeOtroServicioProtegido = servicios.some((s) => {
    // ignorar el servicio actual
    if (s.id === servicio.id) return false;

    // ignorar eliminados o inactivos
    if (!s.activo || s.eliminado) return false;

    const tituloSrv = normalizarTexto(s.title);

    return TITULOS_PROTEGIDOS_REGLAS.some((rx) =>
      rx.test(tituloSrv)
    );
  });

  const mostrarAdvertencia =
    usaTituloProtegido && existeOtroServicioProtegido;

  const motivoTituloBloqueado = mostrarAdvertencia
    ? "Advertencia: ya existe otro servicio activo usando una lógica automática de Kinesiología, Entrenamiento, Masajes, Recovery o similares. Mantener este nombre podría corromper sesiones o automatizaciones."
    : "";

  const tituloBloqueado = false;

  const idsExistentes = servicios
    .filter((s) => s.id !== servicio.id)
    .map((s) => s.id);

  const slugActual = slug(title);

  const slugDuplicado = idsExistentes.includes(slugActual);


  const handleChangeVar = (index, field, value) => {
    setVariantesList((prev) =>
      prev.map((v, i) =>
        i === index
          ? {
              ...v,
              [field]:
                ["precio","precio_grupo","precio_privada"]
                .includes(field)

                ? value.replace(/[^\d]/g,"")

                : value,
            }
          : v
      )
    );
  };

  // DESPUÉS
  const handleAgregarVar = () => {
    setVariantesList((prev) => [
      ...prev,
     {
      id:`tmp-${Date.now()}`,

      nombre:"",

      precio_grupo:"",

      precio_privada:"",

      nivel:"",

      modalidadesPermitidas:{
        privada:true,
        grupal:false,
      }
      },
    ]);
  };


  const handleEliminarVar = (index) => {
    setVariantesList((prev) => prev.filter((_, i) => i !== index));
  };

  const subirImagenServicio = async () => {
  if (!imageFile) return image || "";

  try {
    setSubiendoImagen(true);

    const extension = imageFile.name.split(".").pop();
    const nombreSeguro = servicio.id || `servicio-${Date.now()}`;
    const ruta = `editar_servicios/${nombreSeguro}_${Date.now()}.${extension}`;

    const fileRef = storageRef(storage, ruta);
    await uploadBytes(fileRef, imageFile);

    const url = await getDownloadURL(fileRef);
    return url;
  } catch (error) {
    console.error("Error subiendo imagen del servicio:", error);
    throw error;
  } finally {
    setSubiendoImagen(false);
  }
};

const handleGuardar = async () => {
        try {
    setSaving(true);
    setSaving(true);

    const variantesCanon = variantesList.map((v) => ({
      ...v,
      id: canonizarIdVariante({ servicioId: servicio.id, v, list: variantesList }),
    }));

    const ids = variantesCanon.map((v) => v.id);
    if (new Set(ids).size !== ids.length) {
      alert("Hay IDs de variantes repetidos. Revisa nombres/IDs antes de guardar.");
      setSaving(false);
      return;
    }

    const variantesGuardadas = denormalizarVariantesDesdeEdicion(
      tipoVariantes,
      variantesCanon,
      variantesTexto
    );

    let imageUrl = image.trim();

    if (imageFile) {
      imageUrl = await subirImagenServicio();
    }

    if (!title.trim()) {
      alert("Debes ingresar un título.");
      setSaving(false);
      return;
    }

    if (
      servicio.esNuevo &&
      servicios.some((s) => s.id === slug(title))
    ) {
      alert("Ya existe un servicio con ese ID.");
      setSaving(false);
      return;
    }

    const payload = {
      activo,
      title: title.trim(),
      desc: desc.trim(),
      extra: extra.trim(),
      image: imageUrl,
      orden: Number(orden) || 0,
      variantes: variantesGuardadas,
      actualizadoEn: serverTimestamp(),
    };

    if (servicio.esNuevo) {
      const nuevoId = slug(title);

      const docRef = doc(db, "editar_servicios", nuevoId);

      const existente = await getDoc(docRef);

      if (existente.exists()) {
        alert("Ya existe un servicio con ese nombre.");
        setSaving(false);
        return;
      }

      // recalcular variantes usando el ID limpio
      const variantesCanonFinal = variantesList.map((v) => ({
        ...v,
        id: canonizarIdVariante({
          servicioId: nuevoId,
          v,
          list: variantesList,
        }),
      }));

      const variantesGuardadasFinal =
        denormalizarVariantesDesdeEdicion(
          tipoVariantes,
          variantesCanonFinal,
          variantesTexto
        );

      await setDoc(docRef, {
        ...payload,
        variantes: variantesGuardadasFinal,
        creadoEn: serverTimestamp(),
      });

      onUpdated({
        id: nuevoId,
        ...payload,
        variantes: variantesGuardadasFinal,
      });
    } else {
      const ref = doc(db, "editar_servicios", servicio.id);

      await updateDoc(ref, payload);

      onUpdated({
        ...servicio,
        ...payload,
      });
    }

    onClose();
  } catch (e) {
    console.error("Error actualizando servicio:", e);
    alert("Ocurrió un error al guardar. Revisa la consola.");
  } finally {
    setSaving(false);
  }
};

  return (
    <div className="fixed inset-0 z-[9999] flex justify-center items-start bg-black/40 overflow-y-scroll">
      <div className="my-10 bg-white rounded-xl shadow-xl w-full max-w-3xl p-6">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-xl font-bold text-blue-900">
            {servicio.esNuevo ? "Nuevo servicio" : `Editar servicio: ${servicio.title}`}
          </h3>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-800">
            ✕
          </button>
        </div>

        {/* Campos básicos */}
        <div className="space-y-4">
          {/* Título */}
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Título
            </label>
            <input
              className={`mt-1 w-full border rounded-md px-3 py-2 text-sm ${
                tituloBloqueado
                  ? "border-red-400 bg-red-50 focus:outline-none focus:ring-2 focus:ring-red-200"
                  : ""
              }`}
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />

            {tituloBloqueado && (
              <p className="mt-2 text-sm text-red-600">
                {motivoTituloBloqueado}
              </p>
            )}

            <p className="mt-2 text-xs text-gray-500">
              ID generado:{" "}
              <span className="font-mono text-blue-700">
                {slugActual || "—"}
              </span>
            </p>

            {slugDuplicado && (
              <p className="mt-1 text-sm text-red-600">
                Ya existe un servicio usando este ID.
              </p>
            )}

            <div className="mt-3 text-xs text-gray-500">
              <p className="font-medium mb-1">IDs registrados:</p>

              <div className="flex flex-wrap gap-1">
                {idsExistentes.map((id) => (
                  <span
                    key={id}
                    className="px-2 py-1 rounded bg-gray-100 border text-gray-700 font-mono"
                  >
                    {id}
                  </span>
                ))}
              </div>
            </div>
          </div>

          {/* Descripción */}
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Descripción (desc)
            </label>
            <textarea
              className="mt-1 w-full border rounded-md px-3 py-2 text-sm"
              rows={3}
              value={desc}
              onChange={(e) => setDesc(e.target.value)}
            />
          </div>

          {/* Extra */}
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Texto extra
            </label>
            <textarea
              className="mt-1 w-full border rounded-md px-3 py-2 text-sm"
              rows={2}
              value={extra}
              onChange={(e) => setExtra(e.target.value)}
            />
          </div>

          {/* Ruta imagen + orden + activo */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {/* SELECT DE IMÁGENES */}
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Imagen del servicio
                </label>

                <input
                  type="file"
                  accept="image/*"
                  className="mt-1 w-full border rounded-md px-3 py-2 text-sm bg-white"
                  onChange={(e) => {
                    const file = e.target.files?.[0] || null;
                    setImageFile(file);
                  }}
                />

                <input
                  type="text"
                  className="mt-2 w-full border rounded-md px-3 py-2 text-sm"
                  value={image}
                  onChange={(e) => setImage(e.target.value)}
                  placeholder="O pega aquí una URL manual de imagen"
                />

                {(imageFile || image) && (
                  <img
                    src={imageFile ? URL.createObjectURL(imageFile) : image}
                    alt="preview"
                    className="mt-2 w-32 h-24 object-cover rounded border"
                    onError={(e) => {
                      e.currentTarget.style.display = "none";
                    }}
                  />
                )}

                <p className="mt-2 text-xs text-gray-500">
                  Puedes subir una nueva imagen.
                </p>
              </div>

            {/* Orden */}
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Orden
              </label>
              <input
                type="number"
                className="mt-1 w-full border rounded-md px-3 py-2 text-sm"
                value={orden}
                onChange={(e) => setOrden(e.target.value)}
              />
            </div>

            {/* Activo */}
            <div className="flex items-center gap-2 mt-6">
              <input
                id="chk-activo"
                type="checkbox"
                className="h-4 w-4"
                checked={activo}
                onChange={(e) => setActivo(e.target.checked)}
              />
              <label
                htmlFor="chk-activo"
                className="text-sm font-medium text-gray-700"
              >
                Activo
              </label>
            </div>
          </div>
        </div>

        {/* VARIANTES */}
        <div className="mt-6 border-t pt-4">
          <h4 className="font-semibold text-gray-800 mb-2">
            Variantes del servicio ({tipoVariantes})
          </h4>

          {(tipoVariantes === "array" || tipoVariantes === "map") && (
            <div className="space-y-3">
              {variantesList.map((v, index) => {
                return (
                  <div
                    key={v.id || index}
                    className="p-3 border rounded-lg bg-gray-50"
                  >
                    {/* Nombre */}
                    <div className="mb-2">
                      <label className="block text-xs font-medium text-gray-600">
                        Nombre
                      </label>
                      <input
                        className="mt-1 w-full border rounded-md px-2 py-1 text-sm"
                        value={v.nombre}
                        onChange={(e) =>
                          handleChangeVar(index, "nombre", e.target.value)
                        }
                      />
                    </div>

                    {/* Modalidades */}

                    <div className="border-t pt-3">

                    <label className="block text-xs font-medium text-gray-600 mb-2">

                    Modalidades permitidas

                    </label>

                    <div className="flex gap-6 mb-4">

                    <label className="flex items-center gap-2 text-sm">

                    <input
                    type="checkbox"

                    checked={
                    v.modalidadesPermitidas?.privada ?? true
                    }

                    onChange={(e)=>

                    setVariantesList(prev=>

                    prev.map((item,i)=>

                    i===index

                    ?{

                    ...item,

                    modalidadesPermitidas:{

                    ...(item.modalidadesPermitidas||{}),

                    privada:e.target.checked

                    }

                    }

                    :item

                    )

                    )

                    }

                    />

                    Privada

                    </label>


                    <label className="flex items-center gap-2 text-sm">

                    <input
                    type="checkbox"

                    checked={
                    v.modalidadesPermitidas?.grupal ?? false
                    }

                    onChange={(e)=>

                    setVariantesList(prev=>

                    prev.map((item,i)=>

                    i===index

                    ?{

                    ...item,

                    modalidadesPermitidas:{

                    ...(item.modalidadesPermitidas||{}),

                    grupal:e.target.checked

                    }

                    }

                    :item

                    )

                    )

                    }

                    />

                    Grupal

                    </label>

                    </div>


                    {/* Precio privada */}

                    {v.modalidadesPermitidas?.privada && (

                    <div className="mb-2">

                    <label className="block text-xs font-medium text-gray-600">

                    Precio privada

                    </label>

                    <input

                    className="mt-1 w-full border rounded-md px-2 py-1 text-sm"

                    value={v.precio_privada}

                    onChange={(e)=>

                    handleChangeVar(
                    index,
                    "precio_privada",
                    e.target.value
                    )

                    }

                    />

                    </div>

                    )}


                    {/* Precio grupal */}

                    {v.modalidadesPermitidas?.grupal && (

                    <div className="mb-2">

                    <label className="block text-xs font-medium text-gray-600">

                    Precio grupal

                    </label>

                    <input

                    className="mt-1 w-full border rounded-md px-2 py-1 text-sm"

                    value={v.precio_grupo}

                    onChange={(e)=>

                    handleChangeVar(
                    index,
                    "precio_grupo",
                    e.target.value
                    )

                    }

                    />

                    </div>

                    )}

                    </div>

                    <button
                    type="button"
                    onClick={()=>handleEliminarVar(index)}
                    className="text-xs text-red-600 mt-4"
                    >

                    Eliminar

                    </button>
                  </div>
                );
              })}

              <button
                type="button"
                onClick={handleAgregarVar}
                className="mt-2 inline-flex items-center px-3 py-1.5 rounded-md text-sm bg-blue-600 text-white hover:bg-blue-700"
              >
                + Agregar variante
              </button>
            </div>
          )}
        </div>

        {/* Botones */}
        <div className="mt-6 flex justify-end gap-3">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 rounded-md text-sm border border-gray-300 text-gray-700 bg-white hover:bg-gray-50"
            disabled={saving}
          >
            Cancelar
          </button>
            <button
              type="button"
              onClick={handleGuardar}
              className="px-4 py-2 rounded-md text-sm bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-60 disabled:cursor-not-allowed"
              disabled={saving || subiendoImagen}
              title={tituloBloqueado ? motivoTituloBloqueado : ""}
            >
              {saving || subiendoImagen ? "Guardando..." : "Guardar cambios"}
            </button>
        </div>
      </div>
    </div>
  );
}

// =========================
// LISTA PRINCIPAL
// =========================
export default function ServiciosEditor() {
  const [servicios, setServicios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(null);
  const serviciosActivos = servicios.filter((s) => s.eliminado !== true);
  const serviciosPapelera = servicios.filter((s) => s.eliminado === true);
  const [mostrarPapelera, setMostrarPapelera] = useState(false);

  const restaurarServicio = async (srv) => {
  try {
    await updateDoc(doc(db, "editar_servicios", srv.id), {
      eliminado: false,
      activo: true,
      actualizadoEn: serverTimestamp(),
    });

    setServicios((prev) =>
      prev.map((s) =>
        s.id === srv.id
          ? { ...s, eliminado: false, activo: true }
          : s
      )
    );
  } catch (error) {
    console.error("Error restaurando servicio:", error);
    alert("No se pudo restaurar el servicio.");
  }
};

  // Cargar servicios
  useEffect(() => {
    async function cargar() {
      try {
        const ref = collection(db, "editar_servicios");
        const q = query(ref, orderBy("orden", "asc"));
        const snap = await getDocs(q);

        const lista = snap.docs.map((docSnap) => ({
          id: docSnap.id,
          ...docSnap.data(),
        }));

        setServicios(lista);
      } catch (e) {
        console.error("Error cargando servicios:", e);
      }

      setLoading(false);
    }

    cargar();
  }, []);

  const handleUpdated = (srvActualizado) => {
    setServicios((prev) => {
      const existe = prev.some((s) => s.id === srvActualizado.id);

      if (existe) {
        return prev.map((s) =>
          s.id === srvActualizado.id ? srvActualizado : s
        );
      }

      return [...prev, srvActualizado].sort(
        (a, b) => Number(a.orden || 0) - Number(b.orden || 0)
      );
    });
  };

  const crearServicioNuevo = () => {
    const ordenMax = servicios.reduce(
      (max, s) => Math.max(max, Number(s.orden || s.order || 0)),
      0
    );

    const nuevoTemporal = {
      id: null,
      title: "",
      desc: "",
      extra: "",
      image: "",
      activo: true,
      eliminado: false,
      orden: ordenMax + 1,
      variantes: [],
      esNuevo: true,
    };

    setEditing(nuevoTemporal);
  };

    const toggleActivoServicio = async (srv) => {
    try {
      const nuevoActivo = !srv.activo;

      await updateDoc(doc(db, "editar_servicios", srv.id), {
        activo: nuevoActivo,
        actualizadoEn: serverTimestamp(),
      });

      setServicios((prev) =>
        prev.map((s) =>
          s.id === srv.id ? { ...s, activo: nuevoActivo } : s
        )
      );
    } catch (error) {
      console.error("Error actualizando estado del servicio:", error);
      alert("No se pudo cambiar el estado del servicio.");
    }
  };

    const eliminarServicio = async (srv) => {
    const ok = window.confirm(
      `¿Seguro que deseas eliminar "${srv.title}"? Esta acción lo ocultará del editor y de la vista pública.`
    );

    if (!ok) return;

    try {
      await updateDoc(doc(db, "editar_servicios", srv.id), {
        eliminado: true,
        activo: false,
        actualizadoEn: serverTimestamp(),
      });

      setServicios((prev) => prev.filter((s) => s.id !== srv.id));
    } catch (error) {
      console.error("Error eliminando servicio:", error);
      alert("No se pudo eliminar el servicio.");
    }
  };

  if (loading) {
    return (
      <div className="bg-white p-6 rounded-xl shadow">
        Cargando servicios...
      </div>
    );
  }

  return (
    <div className="bg-white p-4 sm:p-6 rounded-2xl shadow border space-y-6 relative">
      <h2 className="text-xl sm:text-2xl font-bold">Servicios</h2>

       <button
          type="button"
          onClick={crearServicioNuevo}
          className="w-full sm:w-auto px-4 py-2 rounded-xl bg-blue-600 text-white text-sm font-medium hover:bg-blue-700"
        >
          + Nuevo servicio
        </button>

          <button
            type="button"
            onClick={() => setMostrarPapelera((prev) => !prev)}
            className="w-full sm:w-auto px-4 py-2 rounded-xl bg-gray-200 text-gray-800 text-sm font-medium hover:bg-gray-300"
          >
            {mostrarPapelera ? "Ocultar papelera" : `Ver papelera (${serviciosPapelera.length})`}
          </button>


      {servicios.length === 0 && (
        <p className="text-gray-500">No hay servicios registrados.</p>
      )}

      {serviciosActivos.map((srv) => {
        const variantes = normalizarVariantes(srv.variantes);

        return (
        <div
          key={srv.id}
          className="border rounded-2xl p-4 sm:p-5 bg-gray-50 shadow-sm"
        >
          <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
            <div className="min-w-0 flex-1">
              <h3 className="text-xl sm:text-2xl font-bold text-blue-900 break-words">
                {srv.title}
              </h3>
              <p className="text-xs sm:text-sm text-gray-400 mt-1">
                Orden: {srv.orden ?? srv.order ?? "—"}
              </p>
            </div>

            <div className="flex flex-wrap items-center gap-2 sm:justify-end shrink-0">
              {srv.activo ? (
                <span className="px-2.5 py-1 text-xs font-medium rounded-full bg-green-100 text-green-700">
                  Activo
                </span>
              ) : (
                <span className="px-2.5 py-1 text-xs font-medium rounded-full bg-red-100 text-red-700">
                  Inactivo
                </span>
              )}

              <button
                type="button"
                className="w-full sm:w-auto px-4 py-2 bg-blue-600 text-white rounded-xl text-sm font-medium hover:bg-blue-700"
                onClick={() => setEditing(srv)}
              >
                Editar
              </button>

              <button
                type="button"
                className={`w-full sm:w-auto px-4 py-2 rounded-xl text-sm font-medium ${
                  srv.activo
                    ? "bg-amber-100 text-amber-800 hover:bg-amber-200"
                    : "bg-green-100 text-green-800 hover:bg-green-200"
                }`}
                onClick={() => toggleActivoServicio(srv)}
              >
                {srv.activo ? "Desactivar" : "Activar"}
              </button>

              <button
                type="button"
                className="w-full sm:w-auto px-4 py-2 bg-red-100 text-red-700 rounded-xl text-sm font-medium hover:bg-red-200"
                onClick={() => eliminarServicio(srv)}
              >
                Eliminar
              </button>
            </div>
          </div>

            <p className="text-gray-700 mt-3 whitespace-pre-line text-sm sm:text-base leading-relaxed break-words">
              {srv.desc}
            </p>

            {srv.extra && (
              <p className="text-gray-500 text-sm mt-2 whitespace-pre-line leading-relaxed break-words">
                {srv.extra}
              </p>
            )}

            {srv.image && (
              <img
                src={srv.image}
                alt={srv.title}
                className="w-full sm:w-64 h-44 sm:h-40 object-cover rounded-xl mt-4 border"
              />
            )}

            {/* Variantes */}
            <div className="mt-4">
              <h4 className="font-semibold">Variantes del servicio</h4>

              {typeof srv.variantes === "string" && (
                <p className="text-sm text-gray-600 mt-1">
                  {srv.variantes}
                </p>
              )}

              {Array.isArray(srv.variantes) ||
              (typeof srv.variantes === "object" &&
                srv.variantes !== null) ? (
                <>
                  {variantes.length === 0 && (
                    <p className="text-gray-500 text-sm">
                      No hay variantes disponibles.
                    </p>
                  )}

                  {variantes.map((v, i) => (
                    <div
                      key={i}
                      className="mt-2 p-3 sm:p-4 border rounded-xl bg-white flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between"
                    >
                      <div className="min-w-0">
                        {v.nivel && (
                          <p className="text-xs text-gray-400">
                            Nivel: {v.nivel}
                          </p>
                        )}
                        <p className="font-medium break-words">{v.nombre}</p>
                        <p className="text-gray-700 text-sm sm:text-base">
                          ${Number(v.precio || 0).toLocaleString("es-CL")}
                        </p>
                      </div>
                    </div>
                  ))}
                </>
              ) : null}
            </div>
          </div>
        );
      })}

      {mostrarPapelera && (
        <div className="border-t pt-6">
          <h3 className="text-lg font-bold text-gray-800 mb-4">
            Papelera
          </h3>

          {serviciosPapelera.length === 0 ? (
            <p className="text-gray-500">No hay servicios en papelera.</p>
          ) : (
            <div className="space-y-4">
              {serviciosPapelera.map((srv) => (
                <div
                  key={srv.id}
                  className="border rounded-2xl p-4 sm:p-5 bg-gray-100 shadow-sm opacity-90"
                >
                  <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
                    <div className="min-w-0 flex-1">
                      <h3 className="text-xl sm:text-2xl font-bold text-gray-700 break-words">
                        {srv.title}
                      </h3>
                      <p className="text-xs sm:text-sm text-gray-400 mt-1">
                        Orden: {srv.orden ?? srv.order ?? "—"}
                      </p>
                    </div>

                    <div className="flex flex-wrap items-center gap-2 sm:justify-end shrink-0">
                      <span className="px-2.5 py-1 text-xs font-medium rounded-full bg-red-100 text-red-700">
                        En papelera
                      </span>

                      <button
                        type="button"
                        className="w-full sm:w-auto px-4 py-2 bg-green-100 text-green-800 rounded-xl text-sm font-medium hover:bg-green-200"
                        onClick={() => restaurarServicio(srv)}
                      >
                        Restaurar
                      </button>
                    </div>
                  </div>

                  {srv.desc && (
                    <p className="text-gray-600 mt-3 whitespace-pre-line text-sm sm:text-base leading-relaxed break-words">
                      {srv.desc}
                    </p>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      )}

    {editing && (
      <EditarServicioModal
        servicio={editing}
        servicios={servicios}
        onClose={() => {
          setEditing(null);
        }}
        onUpdated={(srvActualizado) => {
          handleUpdated(srvActualizado);
          setEditing(null);
        }}
      />
    )}
    </div>
  );
}
